'use strict';

function getPrimaryCategoryIds(categories) {
  if (!Array.isArray(categories) || !categories.length) {
    return [];
  }

  const result = categories
    .filter(c => !!c.homeOrder)
    .sort(({ homeOrder: a }, { homeOrder: b }) =>
      a === b ? 0 : a > b ? 1 : -1
    )
    .map(c => c.categoryId);

  return result;
}

module.exports = getPrimaryCategoryIds;
